import { ResizePlayerProps } from './types';

export const calculateVideoSize = ({
  videoHeight,
  videoWidth,
  refPreviewContent,
}: ResizePlayerProps) => {
  const scalar = videoWidth > videoHeight ? videoWidth / videoHeight : videoHeight / videoWidth;

  let calculatedVideoWidth = refPreviewContent.offsetWidth;
  let calculatedVideoHeight = calculatedVideoWidth / scalar;

  if (videoHeight > videoWidth) {
    calculatedVideoHeight = refPreviewContent.offsetHeight;
    let additionalCalculatedVideoWidth = calculatedVideoHeight / scalar;

    if (additionalCalculatedVideoWidth > calculatedVideoWidth) {
      additionalCalculatedVideoWidth = calculatedVideoWidth;
      calculatedVideoHeight = additionalCalculatedVideoWidth * scalar;
    }

    return {
      width: `${additionalCalculatedVideoWidth}px`,
      height: `${calculatedVideoHeight}px`,
    };
  }

  if (calculatedVideoHeight > refPreviewContent.offsetHeight) {
    calculatedVideoHeight = refPreviewContent.offsetHeight;
    calculatedVideoWidth = calculatedVideoHeight * scalar;
  }

  return {
    width: `${calculatedVideoWidth}px`,
    height: `${calculatedVideoHeight}px`,
  };
};
